import styled from "styled-components";

export const Container = styled.div`
  background: ${(props) => props.theme.background.default};
  padding: 100px 25px 120px;

  .title {
    font-family: "DM Sans";
    font-weight: 700;
    font-size: 24px;
    color: ${(props) => props.theme.color.default};
  }

  .year-select {
    position: relative;
    .year {
      margin: 40px 0 45px;
      text-align: center;
      color: ${(props) => props.theme.color.active};
      font-family: "Montagu Slab";
      font-weight: 700;
      font-size: 48px;
    }

    button {
      background-color: transparent;
      &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
      }

      > img {
        @media (max-width: 1024px) {
          max-width: 30px;
        }
      }

      &.prev {
        position: absolute;
        left: 28%;
        top: 0;
        @media (max-width: 540px) {
          left: 15%;
        }
        @media (max-width: 414px) {
          left: 6%;
        }
      }

      &.next {
        position: absolute;
        right: 28%;
        top: 0;
        @media (max-width: 540px) {
          right: 15%;
        }
        @media (max-width: 414px) {
          right: 6%;
        }
      }
    }
  }

  .wp-year {
    display: flex;
    align-items: center;
    overflow-x: scroll;
    margin-bottom: 60px;
    margin-left: 7px;

    .name-year {
      text-decoration-line: underline;
      font-family: "Montagu Slab";
      font-weight: 700;
      font-size: 28px;
      color: ${(props) => props.theme.color.opacity};
      margin-right: 45px;
      &:last-child {
        margin-right: 0;
      }

      &__active {
        color: ${(props) => props.theme.color.default};
      }
      @media (max-width: 768px) {
        font-size: 24px;
      }
    }
  }

  .container-content {
    .box {
      margin-bottom: 35px;
      letter-spacing: -0.02em;
      font-family: "Noto Sans KR";
      font-weight: 700;
      font-size: 18px;
      color: ${(props) => props.theme.color.default};

      &:last-child {
        margin-bottom: 0;
      }

      .title-year {
        margin-bottom: 10px;

        &__active {
          color: #c52685;
        }
      }

      .content {
        padding-left: 30px;
        position: relative;
        line-height: 33px;

        &::before {
          content: "";
          position: absolute;
          left: 10px;
          top: 15px;
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background-color: ${(props) => props.theme.color.default};
        }
      }
    }
  }
`;
